import { render, staticRenderFns } from "./BaseEventParameterList.vue?vue&type=template&id=6580dfa4&"
import script from "./BaseEventParameterList.vue?vue&type=script&lang=js&"
export * from "./BaseEventParameterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports